import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminRaffleKeys } from "Api/Queries/Raffle/useAdminRaffleRoundsQuery";
import {
  putAdminRaffleRoundsPublicId,
  type RaffleRoundDto,
  type UpdateRaffleRoundRequest,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: RaffleRoundDto) => void;
  onError?: (error: unknown) => void;
};

type UpdateParams = {
  publicID: string;
  data: UpdateRaffleRoundRequest;
};

export const useUpdateRaffleRoundMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ publicID, data }: UpdateParams) =>
        putAdminRaffleRoundsPublicId(data, publicID),
    ),
    onSuccess,
    onError,
    // Refresh on failure too: a 409 means the round is no longer a draft.
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: adminRaffleKeys.all }),
  });
};
